import styled from "styled-components";
import CloseImg from "@/assets/svg/close.svg";
import { useAccount } from "wagmi";
import { useContractWrite } from 'wagmi'
import { ReactSVG } from "react-svg";
import { useEffect, useState } from "react";
import { ethers } from "ethers";
import { arbitrumGoerli } from 'wagmi/chains'
import { jungleAbi, JungleCA } from '@/utils/abi'
import rightArrow from "@/assets/svg/rightArrow.svg";
import RepayConfirmModal from '@/components/RepayConfirm/Modal'
import ProgressBar from '@/components/ProgressBar'
import { useMemo } from "react";
import { toFixed } from '@/utils/index'

export default function Stake({ handleClose, jusdBalance, totalDebt, successCb, synthValue }) {      
  const [num, setNum] = useState('')
  const [pGrogress, setpGroess] = useState(0)
  const [isOpen, setIsOpen] = useState(false);
  
  const config = {
    mode: 'recklesslyUnprepared',
    address: JungleCA,
    abi: jungleAbi,
    functionName: 'burnJUSD',
    args: [0, ethers.utils.parseUnits(!isNaN(num) && num || '0.0', 18)],
    chainId: arbitrumGoerli.id,
  }
  
  let { writeAsync } = useContractWrite(config)
  
  const fuck = async()=>{
    try {
      const fucker = await writeAsync()
      const waitData = await fucker.wait()
      if(waitData?.status === 1){
        successCb()
      }      
    } catch (error) {
      successCb()
    }
  }
  
  const handleChange = (e)=>{
    const val = e.target.value
    setpGroess(val / totalDebt * 100)
    setNum(val)
  }

  const clickRange = (range)=>{
    if(range === 'MAX'){
      setNum(`${toFixed(totalDebt, 0)}`)      
      setpGroess(toFixed(totalDebt, 0) / totalDebt * 100)      
    }else{
      setNum(`${toFixed(range / 100 * totalDebt, 0)}`)
      setpGroess(range)
    }
  }

  const noBalance =  useMemo(() => {
    return (pGrogress / 100 * synthValue) > jusdBalance
  }, [num, pGrogress])

  const rtDebt =  useMemo(() => {
    return toFixed(num, 5) > totalDebt
  }, [num, totalDebt])

  const payedAfterNum =  useMemo(() => {
    return totalDebt - num
  }, [num, totalDebt])
  
  const onChange = (e)=>{
    setpGroess(e)
    setNum(toFixed(e / 100 * totalDebt, 0))
  }
  const handleClick = ()=>{
    if( (synthValue * pGrogress / 100) > jusdBalance) return
    if(!num) return
    fuck()
    setIsOpen(true)
  }

  
  return (
    <>
      <Modal>
        <div className="close" onClick={handleClose}>
          <ReactSVG src={CloseImg} /> 
        </div>
        <div className="content">
          <div className="title">Repay Debt</div>
          
          <div className="input">
              <div className="field"> 
                <div className="input-title">Amount</div>
                <div className="field-forl">
                  <input className="input-comp" type="number" value={num} placeholder="0.0" onChange={handleChange}/>
                  <div className="r">${toFixed(num, 2)}</div>
                </div>
                <ProgressBar onChange={onChange} value={pGrogress}/>
                <div className="ranges">
                  {
                    ['25', '50', '75', 'MAX'].map((item, idx) => <div className="range-item" key={item} onClick={() => clickRange(item)}>
                      {item}{idx !== 3 && '%'}
                    </div>)
                  }
                </div>
              </div>
          </div>

          
          <div className="info-numer">
            <div className="space-btw">
              <span>Available:</span>
              <span>${(+jusdBalance).toFixed(2)} JUSD</span>
            </div>

            <div className="space-btw">
              <span>Burning:</span>
              <span>${num ? (+num).toFixed(2) : '0.00'} JUSD</span>
            </div>

            <div className="space-btw">
            <span>Personal Total Debt:</span>
              {
                !num ? <span>${(+totalDebt).toFixed(2)}</span> 
                :
                <div className="line-item">
                  <span>${(+totalDebt).toFixed(2)}</span> <ReactSVG src={rightArrow} className="right-arrow"/> <span>${payedAfterNum}</span>
                </div>
              }
          </div>
          </div>
          {
            noBalance && <div className="error-text">Your JUSD in the debt pool is not enough to repay the debt, please sell part of the jSynth in the debt pool first.</div>
          }
          <div onClick={handleClick} className={`stake-btn ${!num || noBalance || rtDebt ? 'disabled' : ''}`}>Repay</div>          
        </div>
      </Modal>      
      <RepayConfirmModal isOpen={isOpen} handleClose={() => setIsOpen(false)} amount={num}/> 
    </>
  );
}

const Modal = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  padding:32px 35px 0 35px;
  .close {
    position: absolute;
    right: 35px;
    top: 40px;
    cursor: pointer;
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      align-self: flex-start;
      padding-bottom:23px;
      font-weight: 600;
      font-size: 24px;
      line-height: 34px;
      color: #32DE86;      
    }
    
    .input {
      width: 100%;
      box-sizing: border-box;    
      .input-title{
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;        
        color: rgba(255, 255, 255, 0.6);
        padding-bottom:11px;
      }
      .field-forl{
        display: flex;
        justify-content: space-between;
      }
      .ranges{
          display: flex;
          justify-content: space-between;
          padding-top:25px;
          .range-item{
            width: 56px;
            height: 27px;
            line-height: 27px;
            text-align: center;
            box-sizing: border-box;
            border-radius:4px;
            border: 1px solid #32DE86;
            cursor: pointer;
            font-weight: 400;
            font-size: 12px;            
            color: #32DE86;
          }
        }
      .field{
        background: rgba(255, 255, 255, 0.06);
        border-radius: 8px;
        padding: 13px 13px 18px 15px;
         
        .radius{
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #fff;
          margin-right: 2px;
        }
        
        .token{
          display: flex;
          align-items: center;
          color: rgba(255, 255, 255, 0.5);
        }
        .r{
          display: flex;
          font-weight: 400;
          font-size: 16px;
          line-height: 22px;          
          color: #fff;
        }
        
        .input-comp {
          background: transparent;
          outline: 0;
          border: 0;
          color: #fff;
          font-weight: 600;
          font-size: 22px;
          max-width: 270px;
          line-height: 22px;        
        }      
        .r{
          display: flex;
          align-items: center;
        }
      }
      
    }    
    .info-numer{
      width: 100%;      
      padding-top: 22px;
    }
    .error-text{
      font-size: 14px;
      padding-top: 5px;
      color: #FF8A00;
    }
    .stake-btn{
      width: 100%;
      box-sizing: border-box;
      height: 44px;
      line-height: 44px;
      background: #32DE86;
      border-radius: 8px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      margin: 13px 0 16px 0;
      cursor: pointer;
      font-size: 16px;
      &:hover{
        background:#239B5E; 
      }
      &.disabled{
        background: rgba(255, 255, 255, 0.1);
        color: rgba(255, 255, 255, 0.3);
        cursor: auto;
      }
    }
    
    .space-btw{
      display: flex;
      justify-content: space-between;
      width: 100%;
      font-size: 14px;
      line-height: 20px;
      color: rgba(255, 255, 255, 0.6);
      & + .space-btw {
        margin-top: 6px;
      }
      .line-item{
        display: flex;
        align-items: center;
        .right-arrow{
          margin: 0 5px;
        }
      }
    } 

  }
`;
